/**
 * Init the scroll indicator
 */
export const initScrollIndicator = function () {
  const scroll = $(window).scrollTop();
  if (scroll === 0) {
    $('.full-screen-image-slice').addClass('full-screen-image-slice--at-top');
  } else {
    $('.full-screen-image-slice').removeClass('full-screen-image-slice--at-top');
  }
};